{
  "nl": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Toegewezene toevoegen",
        "bulk_remove": "Verwijderen uit taak",
        "change_status": "Status wijzigen",
        "confirm": "Markeer als afgerond",
        "create": "Taak",
        "delete": "Toegewezene verwijderen",
        "document_add": "Bestand toevoegen",
        "document_delete": "Verwijderen",
        "due_in_month": "Over een maand",
        "due_in_two_weeks": "Over twee weken",
        "due_in_week": "Over een week",
        "due_remove": "Deadline verwijderen",
        "move_to_draft": "Naar concept",
        "open": "Openen",
        "reopen": "Heropenen",
        "selectAll": "Selecteer alle {total}",
        "send_and_notify": "Versturen en informeren",
        "set_due_date": "Deadline instellen",
        "set_status": "Status instellen",
        "unSelectAll": "Selectie opheffen",
        "upload_files": "Upload {count} bestand | Upload {count} bestanden"
      },
      "assignee_scopes": {
        "external": "Extern",
        "internal": "Intern"
      },
      "assignee_types": {
        "customer": "Klant",
        "employee": "Teamlid",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Toegewezene",
        "assignees": "Toegewezenen",
        "comment": "Opmerking",
        "created_at": "Aangemaakt",
        "document": "Document",
        "due_date": "Deadline",
        "project": "Project",
        "status": "Status",
        "task": "Taak",
        "unit": "Unit"
      },
      "confirm": {
        "affected": "Dit raakt {customers} en {team}.",
        "affected_customers": "Dit raakt {customers}.",
        "affected_team": "Dit raakt {team}.",
        "bulk_affected": "Dit schrijft {count} taak. | Dit schrijft {count} taken.",
        "bulk_delete_body": "De taak blijft bestaan, op deze eenheid en op alle andere. Alleen de geselecteerde rijen verdwijnen.",
        "bulk_delete_header": "Deze taken verwijderen?",
        "complete_body": "Hun taken worden voor hen afgesloten en verdwijnen uit hun lijst, ook als ze niets hebben gedaan.",
        "complete_header": "Deze taak voor iedereen afsluiten?",
        "customer_tasks": "{count} klanttaak | {count} klanttaken",
        "delete_body": "Alleen deze ene toewijzing verdwijnt. De taak houdt haar andere toegewezenen en haar andere eenheden.",
        "delete_header": "{name} van deze taak verwijderen?",
        "delete_sent_customers": "Deze was al verstuurd, dus ze verdwijnt ook uit het klantenportaal van {unit}.",
        "delete_sent_team": "Deze was al verstuurd, dus ze verdwijnt ook uit de lijst van {name}.",
        "document_delete_body": "Het bestand verdwijnt ook uit de documenten van de unit.",
        "document_delete_header": "Dit bestand verwijderen?",
        "draft_body": "De taak verdwijnt tot ze opnieuw wordt verstuurd. E-mails die al zijn verstuurd, blijven verstuurd.",
        "draft_header": "Deze taak terugzetten naar concept?",
        "send_customers": "Klanten zien de taak meteen in hun portaal en krijgen een melding.",
        "send_header": "Naar de toegewezen personen sturen?",
        "send_permanent": "Versturen kan niet ongedaan worden gemaakt. De taak later terugzetten naar concept haalt de melding niet terug.",
        "send_status": "Ze komen op Gevraagd te staan.",
        "send_team": "Teamleden krijgen een melding.",
        "team_tasks": "{count} teamtaak | {count} teamtaken"
      },
      "deep_link": {
        "completed": "Deze taak is al afgerond.",
        "gone": "Deze taak is niet meer open."
      },
      "empty": {
        "filtered_description": "Pas je filters aan of wis ze om alle toewijzingen te zien.",
        "filtered_title": "Geen toewijzingen komen overeen met je filters",
        "none_title": "Geen toewijzingen"
      },
      "filters": {
        "due_window_values": {
          "month": "Deadline binnen een maand",
          "none": "Geen deadline",
          "overdue": "Te laat",
          "week": "Deadline binnen een week"
        },
        "show_only": "Toon enkel",
        "show_only_values": {
          "customers": "Klanten",
          "mine": "Toegewezen aan mij",
          "team": "Team"
        }
      },
      "labels": {
        "add_assignee": "Een toegewezene toevoegen",
        "add_customers": "Klanten toevoegen",
        "already_assigned": "Deze taak is al toegevoegd aan deze eenheid.",
        "already_assigned_project": "Deze taak is al toegevoegd aan dit project.",
        "assignees": "Toegewezenen",
        "assignees_subtitle": "Elk krijgt een eigen taak, per unit.",
        "assignees_title": "Wie moet het doen",
        "comment_earlier_round": "eerdere ronde",
        "comment_placeholder": "bv. de meter was moeilijk bereikbaar, dit is de beste foto die ik kon nemen",
        "comments_none": "De klant liet geen opmerking achter.",
        "comments_title": "Opmerkingen bij deze taak",
        "completed": "Afgerond",
        "confirm_message": "Weet je zeker dat je deze taak als afgerond wilt markeren?",
        "customers": "Klanten",
        "documents_none": "Er is nog niets geüpload.",
        "documents_title": "Bestanden bij deze taak",
        "earlier": "+{count} eerder",
        "my_tasks": "Mijn taken",
        "no_assignees": "Nog geen toegewezenen.",
        "no_assignments": "Nog geen taken.",
        "no_assignments_task": "Nog geen toewijzingen voor deze taak.",
        "no_assignments_unit": "Nog geen taken voor deze unit.",
        "previous_upload": "vorige upload",
        "required": "Dit veld is verplicht",
        "selectOne": "Selecteer minstens één taak.",
        "select_task": "Selecteer een taak",
        "selected": "{selected} geselecteerd | {selected} geselecteerd",
        "set_status_for": "Status instellen voor {name}",
        "superseded": "vervangen",
        "totalSelected": "Alle {total} geselecteerd",
        "upload_hint": "Upload het gevraagde document of de gevraagde documenten om deze taak te voltooien.",
        "uploaded_documents": "Geüploade documenten"
      },
      "statuses": {
        "completed": "Afgerond",
        "draft": "Concept",
        "requested": "Gevraagd"
      },
      "toasts": {
        "bulk_delete": "Taken verwijderd",
        "bulk_update": "Taken bijgewerkt",
        "completed": "Taak afgerond",
        "create": "Taak aangemaakt",
        "delete": "Toegewezene verwijderd",
        "document_added": "Bestand toegevoegd",
        "document_deleted": "Bestand verwijderd",
        "reopened": "Taak heropend",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
